import { useEffect } from "react";
import { useFileStore } from "../../../../store/useFileStore";

const DarkMatter = () => {
    const [_, setStore] = useFileStore((store) => store.darkMatter);

    useEffect(() => {
        let value = `import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";

const DarkMatter = () => {
    const position = [51.505, -0.09];
    return (
        <MapContainer
            style={{ width: "100%", height: "400px" }}
            center={position}
            zoom={16}
            scrollWheelZoom={false}
        >
            <TileLayer
                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
                url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
            />
            <Marker position={position}>
                <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
            </Marker>
        </MapContainer>
    );
};

export default DarkMatter;
`;
        setStore({ darkMatter: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};

export default DarkMatter;
